module.exports = __webpack_public_path__ + "img/icon-drag-n-drop-blue.f9a977f9.svg";